

export class PriceVision {

    mill_id?: number
    market_day?: string
    price_per_kg?: number
    quantity?: number
    created_at?: string
    updated_at?: string
    numContracts?: number
    numSuppliers?: number
    avgGradingByContract?: number
    maxGrading?: number


    constructor(data: any) {
        this.market_day = data.day
        this.price_per_kg = data.bid_close
        this.quantity = data.gross_volume
        this.mill_id = data.mill_id
        this.created_at = data._created_at
        this.updated_at = data._updated_at
        this.numContracts = data.num_contracts
        this.numSuppliers = data.num_suppliers
        this.avgGradingByContract = data.avg_grading_by_contract ? data.avg_grading_by_contract * 100 : undefined
        this.maxGrading = data.max_grading ? data.max_grading * 100 : undefined
    }

    static buildPriceVision(data: any): PriceVision {
        return new PriceVision(data)
    }
}